import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 35,
    width: 262,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
  },
  title: {
    color: theme.colors.grey5,
    ...theme.typography.header5,
  },
  appointmentsContainer: {
    marginTop: 10,
    borderRadius: 5,
    borderWidth: 1,
    border: 'solid',
    borderColor: theme.colors.grey2
  },
  appointmentsHeader: {
    minHeight: 40,
    borderRadius: 5,
    background: theme.colors.grey1,
    paddingLeft: 18,
    display: 'flex',
    alignItems: 'center',
  },
  emptyContentContainer: {
    width: 209,
    minHeight: 432,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    alignItems: 'center',
    justifyContent: 'center'
  },
  emptyContentTitle: {
    textAlign: 'center',
    color: theme.colors.clearMain,
    ...theme.typography.header5,
    fontSize: 16,
  },
  emptyContentBody: {
    textAlign: 'center',
    color: theme.colors.grey4,
    ...theme.typography.txtBody2,
  },
  appointmentsList: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 16px 22px 16px',
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#c1c1c1 #f5f5f5',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
  },
  appointmentCardContainer: {},
  appointmentCard: {
    paddingTop: 7,
    paddingBottom: 7,
    paddingRight: 4,
    paddingLeft: 4,
    borderRadius: 5,
    borderWidth: 1,
    border: 'solid',
    borderColor: theme.colors.grey2,
    marginTop: 8,
  },
  appointmentDate: {
    ...theme.typography.txtBody2,
    color: theme.colors.grey5,
    fontWeight: 700,
    marginTop: 15,
    marginBottom: 15
  },
  serviceItem: {
    marginTop: 0,
  },
  serviceName: {
    ...theme.typography.caption1,
    color: theme.colors.grey5,
    fontWeight: 700,
  },
  serviceTime: {
    ...theme.typography.caption2,
    color: theme.colors.grey5,
  },
  serviceSpecialist: {
    ...theme.typography.caption2,
    color: theme.colors.grey5,
  },
  postServiceNotes: {
    marginTop: 10,
  },
  notesTitle: {
    ...theme.typography.caption1,
    color: theme.colors.grey5,
    fontWeight: 700,
  },
  notesContent: {
    ...theme.typography.caption2,
    color: theme.colors.grey5,
    wordBreak: 'break-word',
  },
  seeMoreToggle: {
    ...theme.typography.caption2,
    color: theme.colors.clearMain,
    fontWeight: 700,
    cursor: 'pointer',
  },
  seeMoreButton: {
    marginTop: 16,
    padding: '8px 16px',
    borderRadius: 5,
    borderColor: theme.colors.clearMain,
    color: theme.colors.clearMain,
    borderWidth: 1,
    border: 'solid',
    cursor: 'pointer',
    '&:disabled': {
      color: theme.colors.clearMain,
      opacity: 0.3
    }
  },
  seeMoreButtonText: {
    ...theme.typography.buttons,
    fontWeight: 700,
  },
}));

export default useStyles;
